// extracted by mini-css-extract-plugin
module.exports = {"msTouch":"QfA9vJ","slider":"eJdRw6","dots":"d2Z0ec"};